import { isAndroid, isBrowser, isIOS, isMobile, isTablet } from 'react-device-detect';

export const isMobileVersion = !isBrowser || isAndroid || isIOS || isMobile || isTablet;
